module.exports = __webpack_public_path__ + "img-front/register/recover.049f676c.svg";